import React from "react";
import CloseIcon from '@material-ui/icons/Info';
import styles from "./Warning.module.scss";

const Warning = props => {
  let icon = null;
  let className = null;
  switch (props.type) {
    case 'warning':
      icon = <CloseIcon className={styles.icon}/>;
      className = styles.warning;
      break;
    case 'error':
      icon = <CloseIcon className={styles.icon}/>;
      className = styles.error;
      break;
    case 'success':
      icon = <CloseIcon className={styles.icon}/>;
      className = styles.success;
      break;
  }

  return <div className={`${className} ${props.className || ''}`}>
    <div className={styles.warningIcon}>
      {icon}
    </div>
    <div className={styles.warningCopy}>
      {props.title ?
        <p><em>{props.title}</em></p> : null}
      <p>{props.description}</p>
    </div>
  </div>
};

export default Warning;

